import React from "react";
import * as PropTypes from "prop-types";
import ComponentWithIeFallback from "../../widgets/ComponentWithIeFallback";
import SimpleThemeSummary from "./SimpleThemeSummary";
import ThemeSummary from "./ThemeSummary";

const ThemeSummaryController = props => (
  <ComponentWithIeFallback
    fallbackComponent={
      <SimpleThemeSummary reference={props.reference} title={props.title}>
        {props.children}
      </SimpleThemeSummary>
    }
  >
    <ThemeSummary
      reference={props.reference}
      title={props.title}
      shift={props.shift}
    >
      {props.children}
    </ThemeSummary>
  </ComponentWithIeFallback>
);

ThemeSummaryController.propTypes = {
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  shift: PropTypes.bool,
  children: PropTypes.string.isRequired
};

export default ThemeSummaryController;
